<template>
  <div class="home">
    <!-- <header-nav v-if="showheader"></header-nav> -->
    <div class="hoverList" v-show="showHover">
      <img
        src="../assets/gh/zs.png"
        alt=""
        class="headZs"
        @mouseenter="isMqtHover = true"
        @mouseleave="isMqtHover = false"
        style="cursor: pointer;"
      />
      <div
        class="hoverItem"
        @mouseenter="isMqtHover = true"
        @mouseleave="isMqtHover = false"
        :style="{
          zIndex: 101,
          
          background: isMqtHover
            ? 'linear-gradient(to right,#399777, #ffffff)'
            : '',
          'border-top-left-radius': '10px'
        }"
      >
        <a
          @click="gouserp"
          href="javascript:void(0);"
          :style="{ color: !isMqtHover ? '#000000' : '#ffffff' }"
          style="text-decoration:none"
        >
          <img src="../assets/gh/new1.png" v-show="!isMqtHover" alt="" style="height:auto"/>
          <img src="../assets/gh/new2.png" v-show="isMqtHover" alt="" style="height:auto"/>
          蒙企通</a
        >
      </div>
      <div
        class="hoverItem"
        @mouseenter="isWxHover = true"
        @mouseleave="isWxHover = false"
        :style="{
          
          background: isWxHover
            ? 'linear-gradient(to right,#399777, #ffffff)'
            : ''
        }"
      >
        <a
          :style="{ color: !isWxHover ? '#000000' : '#ffffff' }"
          style="text-decoration:none"
        >
          <img src="../assets/gh/wx.png" v-show="!isWxHover" alt="" />
          <img
            src="../assets/gh/wxEd.png"
            v-show="isWxHover"
            alt=""
          />微信关注</a
        >
        <div class="code" v-show="isWxHover">
          <img src="../assets/gh/code.jpg" alt="" />
          <span>蒙企通小程序</span>
        </div>
      </div>
      <div
        class="hoverItem"
        @mouseenter="isYhzyHover = true"
        @mouseleave="isYhzyHover = false"
        :style="{
          background: isYhzyHover
            ? 'linear-gradient(to right,#399777, #ffffff)'
            : ''
        }"
      >
        <a
          @click="gouserS"
          href="javascript:void(0);"
          :style="{ color: !isYhzyHover ? '#000000' : '#ffffff' }"
          style="text-decoration:none"
        >
          <img src="../assets/gh/new3.png" v-show="!isYhzyHover" alt="" />
          <img src="../assets/gh/new4.png" v-show="isYhzyHover" alt="" />
          用户指引</a
        >
      </div>
      <div
        class="hoverItem"
        @mouseenter="isWzaHover = true"
        @mouseleave="isWzaHover = false"
        :style="{
          background: isWzaHover
            ? 'linear-gradient(to right,#399777, #ffffff)'
            : ''
        }"
      >
        <a
          id="toolbarSwitch"
          href="javascript:void(0);"
          :style="{ color: !isWzaHover ? '#000000' : '#ffffff' }"
          style="text-decoration:none"
        >
          <img src="../assets/gh/wza.png" v-show="!isWzaHover" alt="" />
          <img src="../assets/gh/wzaEd.png" v-show="isWzaHover" alt="" />
          无障碍浏览</a
        >
      </div>
      <div
        class="hoverItem"
        @mouseenter="isZZHover = true"
        @mouseleave="isZZHover = false"
        :style="{
          background: isZZHover
            ? 'linear-gradient(to right,#399777, #ffffff)'
            : ''
        }"
      >
        <a
          @click="goElderIndex"
          href="javascript:void(0);"
          :style="{ color: !isZZHover ? '#000000' : '#ffffff' }"
          style="text-decoration:none"
        >
          <img src="../assets/gh/zz.png" v-show="!isZZHover" alt="" />
          <img src="../assets/gh/zzEd.png" v-show="isZZHover" alt="" />
          长者浏览模式</a
        >
      </div>

      <div
        class="hoverItem"
        @click="toTop"
        :style="{ 'border-bottom-left-radius': '10px' }"
      >
        <img src="../assets/gh/top.png" alt="" />
        <span>置顶</span>
      </div>
    </div>
    <div class="toubu" ref="refname" v-html="head"></div>
    <router-view to="/"></router-view>

    <!--    <footer-nav v-if="showfooter"></footer-nav> -->
  </div>
</template>
<script>
// import HeaderNav from "@/views/headerNav.vue";
// import FooterNav from "@/views/footerNav.vue";
import { store } from "@/store/index";
const { uuid } = store.state.userInfo;
import { getmsg } from "@/api/news.js";
import { get } from "lodash";
export default {
  // components: {
  //   HeaderNav,
  //   FooterNav
  // },
  data() {
    return {
      showHover: true,
      message: "",
      showheader: true,
      showfooter: true,
      head: [],
      isWxHover: false,
      isWzaHover: false,
      isZZHover: false,
      isYhzyHover: false,
      isMqtHover: false
    };
  },
  watch: {
    $route: {
      //用来监听query参数变化
      handler(e) {
        console.log(e, "gxn");

        this.showheader = this.$route.meta.showheader;
        this.showfooter = this.$route.meta.showfooter;
        const { fullPath } = e;
        if (fullPath.indexOf("elder") != -1) {
          this.showHover = false;
        } else {
          this.showHover = true;
        }
        //深度监听，同时也可监听到param参数变化
      },
      deep: true
    }
  },
  created() {
    let that = this;
    // 部署

    this.backurlcut();

    // if (this.$cookies.get("first")) {
    // } else {
    //   that.$cookies.set("first", 1, -1);
    //   this.$router.go(0);
    // }
  },
  mounted() {
    // console.log(this.desensitizedName("巩啸南"))
  },
  methods: {
    gouserp() {
      setTimeout(() => {
        window.open(
          this.$router.resolve("/publicityGuidelines").href,
          "_blank"
        );
      }, 500);
    },
    gouserS() {
      setTimeout(() => {
        window.open(
          this.$router.resolve("/publicityGuidelinesPc").href,
          "_blank"
        );
      }, 500);
    },
    goElderIndex() {
      this.$router.push("/elder/elderIndex");
      setTimeout(() => {
        EsdToolbar2.close();
      }, 500);
    },
    toTop() {
      document.documentElement.scrollTop = 0;
    },
    backurlcut() {
      // url返回取值
      let that = this;
      let url = location.href;
      let p = url.split("?")[1];
      let params = new URLSearchParams(p);
      let msb = params.get("msb") && params.get("msb").slice(3);
      msb && that.$cookies.set("customMsb", msb, -1);
      // 部署
      let params1 = {
        SSOSign: msb || that.$cookies.get("customMsb")
      };
      if (this.$store.state.env == "dev") {
        //本地调试
        if (params.get("msb")) {
          let params1 = {
            SSOSign: params.get("msb").slice(3)
          };
        }

        that.$cookies.set("msbname", "gxn测试", -1);
        that.$cookies.set("id", 87, -1);
        that.$cookies.set("phone", "17625615042", -1);
        that.$cookies.set("company_id", 271, -1);
        that.$cookies.set("uuid", "5127eb85-4310-372d-912c-64277a609f11", -1);
        that.$cookies.set("USER_TYPE", 1, -1);
        that.$cookies.set("areaDefault", "内蒙古自治区/呼和浩特市/赛罕区", -1);
        that.$cookies.set(
          "companyinfo",
          { is_admin: "", company_name: "土默特右旗萨拉齐红高粱关东糖酒经销部" },
          -1
        );
        that.$cookies.set("is_admin", 2, -1);
        that.$cookies.set("islogin", 1, -1);

        console.log(that.$cookies.get("is_admin"), "用户id");
        setTimeout(() => {
          that.$store.state.msbname = that.$cookies.get("msbname");
          that.$store.state.userInfo.id = that.$cookies.get("id");
          that.$store.state.userInfo.phone = that.$cookies.get("phone");
          that.$store.state.userInfo.company_id = that.$cookies.get(
            "company_id"
          );
          that.$store.state.userInfo.uuid = that.$cookies.get("uuid");
          that.$store.state.userInfo.USER_TYPE = that.$cookies.get("USER_TYPE");
          that.$store.state.userInfo.areaDefault = that.$cookies.get(
            "areaDefault"
          );
          that.$store.state.companyinfo = that.$cookies.get("companyinfo");
          that.$store.state.companyinfo.is_admin = that.$cookies.get(
            "is_admin"
          );
        }, 1000);
        this.creathead();
        return false;
      } else {
        getmsg(params1).then(res => {
          console.log(res, "用户登录1信息");
          that.$nextTick(() => {
            if (get(res, "data.m_acount")) {
              const { name, id, phone, m_acount, uuid, msb_userInfo } = get(
                res,
                "data"
              );
              that.$cookies.set("msbname", name, -1);
              that.$cookies.set("id", id - 1);
              that.$cookies.set("phone", phone, -1);
              that.$cookies.set("company_id", m_acount.mmid, -1);
              that.$cookies.set("uuid", uuid, -1);
              that.$cookies.set("USER_TYPE", msb_userInfo.USER_TYPE, -1);
              that.$cookies.set(
                "areaDefault",
                get(res, "data.m_acount.m_mobiles.area"),
                -1
              );
              that.$cookies.set(
                "companyinfo",
                get(res, "data.m_acount.m_mobiles"),
                -1
              );
              that.$cookies.set(
                "is_admin",
                get(res, "data.m_acount.is_admin"),
                -1
              );

              console.log(that.$cookies.get("is_admin"), "用户id");

              that.$store.state.msbname = name;
              that.$store.state.userInfo.id = id;
              that.$store.state.userInfo.phone = phone;
              that.$store.state.userInfo.company_id = m_acount.mmid;
              that.$store.state.userInfo.uuid = uuid;
              that.$store.state.userInfo.USER_TYPE = msb_userInfo.USER_TYPE;
              that.$store.state.userInfo.areaDefault = get(
                res,
                "data.m_acount.m_mobiles.area"
              );
              that.$store.state.companyinfo = get(
                res,
                "data.m_acount.m_mobiles"
              );
              that.$store.state.companyinfo.is_admin = get(
                res,
                "data.m_acount.is_admin"
              );
              $("#user_name").text(that.$store.state.msbname || "暂无");
            } else {
              that.$cookies.set("msbname", get(res, "data.name"), -1);
              that.$store.state.msbname = get(res, "data.name");
            }
          });

          console.log(that.$store.state.userInfo, "用户信息");
          this.creathead();
        });
      }
    },
    /**
     * 名字脱敏 保留首位
     * @param fullName
     * @returns {string}
     */
    desensitizedName(fullName) {
      if (!fullName) {
        return "";
      }

      let str = fullName.substr(0, 1);
      for (let i = 0; i < fullName.length - 1; i++) {
        str += "*";
      }

      return str;
    },

    creathead() {
      //创建头部
      let _this = this;
      var url =
        "https://zwfw.nmg.gov.cn/commonout_title_head?isLogin=true&title=";
      $.ajax({
        url: url,
        type: "get",
        success: function(data) {
          console.log("creathead");
          _this.head = data;
          _this.$nextTick(() => {
            let url = location.href;
            let p = url.split("?")[1];
            let params = new URLSearchParams(p);
            /* 1111111111111截取字符串111111111111111 */
            if (_this.$cookies.get("islogin") == 1) {
              $("#head_login").hide();
              $("#head_logout").show();
              $("#head_register").hide();
              $("#head_login")
                .next()
                .hide();
            } else {
              _this.$cookies.remove("first");
              $("#head_login").show();
              $("#head_logout").hide();
              $("#head_register").show();
              $("#head_login")
                .next()
                .show();
              $("#userMess").css("background", "#ffffff");
              $("#user_name").hide();
              $("#userMess")
                .find("span")
                .hide();
              // $("#userMess li:first").hide()
            }
            $("#userMess").show();
            $("#curr_region_name").text("“蒙企通”民营企业综合服务平台");
            // document.getElementById('#userMess').style.display='block'logout
            $("#isLogin").show();
            let name;
            let preinstall = "";

            // if (_this.$store.state.msbname) {
            //   //   console.log(_this.$store.state.msbname.length - 1)
            //   // forEach(_this.$store.state.msbname.length - 1, () => {

            //   //   });
            //   for (let i = 0; i < _this.$store.state.msbname.length - 1; i++) {
            //     console.log(preinstall, "preinstall");
            //     preinstall += "*";
            //   }
            //   console.log(preinstall, "preinstall");
            //   name =
            //     "欢迎您 " +
            //     _this.$store.state.msbname.replace(
            //       _this.$store.state.msbname.slice(
            //         0,
            //         _this.$store.state.msbname.length - 1
            //       ),
            //       preinstall
            //     );
            // } else {
            //   name = "暂无";
            // }
            if (_this.$store.state.companyinfo && _this.$store.state.companyinfo.company_name) {
              name = "欢迎 " + _this.$store.state.companyinfo.company_name;
            } else {
              if (_this.$store.state.msbname) {
                name = _this.desensitizedName(_this.$store.state.msbname);
              } else {
                name = "暂无";
              }
              
            }

            $("#user_name").text(name);
            /* $("#user_name").next().attr("href",
                 "https://zwfw.nmg.gov.cn/testsso/sso/main?utype=0&client_id=HVOZX7MRM&goto=http://172.5.13.116:8080"
               ); */
            $("#user_name")
              .next()
              .hide();
            /* $("#head_logout").attr("href",
                 "https://zwfw.nmg.gov.cn/testsso/sso/logout?utype=0&client_id=HVOZX7MRM&goto=https://test-mqtpc.nmghx.cn&gb=istrue"
               ); */
            $("#head_logout").on("click", function() {
              /* 清除本地缓存信息 */
              _this.$cookies.remove("msbname");
              _this.$cookies.remove("id");
              _this.$cookies.remove("phone");
              _this.$cookies.remove("company_id");
              _this.$cookies.remove("uuid");
              _this.$cookies.remove("USER_TYPE");
              _this.$cookies.remove("areaDefault");
              _this.$cookies.remove("companyinfo");
              _this.$cookies.remove("is_admin");
              _this.$cookies.remove("first");
              _this.$cookies.remove("customMsb");
              _this.$store.state.msbname = null;
              _this.$store.state.userInfo.id = null;
              _this.$store.state.userInfo.phone = null;
              _this.$store.state.userInfo.company_id = null;
              _this.$store.state.userInfo.uuid = null;
              _this.$store.state.userInfo.USER_TYPE = null;
              _this.$store.state.userInfo.areaDefault = null;
              _this.$store.state.companyinfo = null;
              _this.$store.state.companyinfo.is_admin = null;
            });

            if (_this.$store.state.env == "pro") {
              /* 1111111111111111111111111111111111 正式 111111111111111111111111111111 */
              $("#head_logout").attr(
                "href",
                "https://zwfw.nmg.gov.cn/sso/sso/logout?utype=0&client_id=HVOZX7MRM&goto=https://mqt.huaxun.ink/pc&gb=istrue"
              );
              $("#logMess").show();
              $("#head_login").attr(
                "href",
                "https://zwfw.nmg.gov.cn/sso/sso/login?utype=0&client_id=HVOZX7MRM&goto=test"
              );
              $("#head_register").attr(
                "href",
                "https://zwfw.nmg.gov.cn/sso/sso/register?utype=0&client_id=HVOZX7MRM&goto=https://mqt.huaxun.ink/pc&gb=istrue"
              );
            } else {
              // 11111111111111111111111111111111111以下为测试111111111111111111111
              $("#head_logout").attr(
                "href",
                "https://zwfw.nmg.gov.cn/testsso/sso/logout?utype=0&client_id=46ONJLJJB&goto=https://test-mqtpc.huaxun.ink&gb=istrue"
              );

              $("#logMess").show();

              $("#head_login").attr(
                "href",
                "https://zwfw.nmg.gov.cn/testsso/sso/login?utype=0&client_id=46ONJLJJB&goto=test"
              );
              $("#head_register").attr(
                "href",
                "https://zwfw.nmg.gov.cn/testsso/sso/register?utype=0&client_id=46ONJLJJB&goto=https://test-mqtpc.huaxun.ink&gb=istrue"
              );
            }
          });

          /*  console.log(_this.$refs.refname, '页面元素') */
          // console.log($("#userMess"),'页面元素')
          _this.$forceUpdate();
        }
      });
    }
  }
};
</script>

<style>
.zwfw_header_top_right_b a {
  padding-left: 10px;
}
.home {
  margin: 0;
  padding: 0;
}
.hoverList {
  background: #f5f5f5;
  position: fixed;
  right: 10px;
  top: 35%;
  /* width: 80px; */
  z-index: 999;
  color: #000000;
  box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.1);
  width: 100px;
  border-bottom-left-radius: 10px;
  border-top-left-radius: 10px;
}
.hoverList .headZs {
  height: 125px;
  width: 125px;
  position: absolute;
  top: -14%;
  left: 0;
  z-index: 100;
  left: 10px;
}
.hoverItem {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 12px;
  cursor: pointer;
  position: relative;
  height: 80px;
  font-size: 12px;
  background-color: #ffffff;
}
.hoverItem .WzaHover {
  color: #ffffff;
}
.hoverItem img {
  width: 30px;
  height: 30px;
  margin-bottom: 5px;
}
.hoverItem a {
  text-decoration: none;
  color: #000000;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.hoverItem .code {
  position: absolute;
  left: -230%;
  top: -50%;
  background-image: url("../assets/gh/bgcode.png");
  background-size: 100% 100%;
  width: 230px;
  height: 200px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 14px;
}
.hoverItem .code img {
  width: 120px;
  height: 120px;
  margin-bottom: 0;
  margin-bottom: 12px;
}

.hoverList .top {
  display: block;
  width: 100%;
  height: 30px;
  line-height: 30px;
  font-size: 16px;
  color: #fff;

  cursor: pointer;
  text-align: center;
  background-color: #399777;
}
</style>



// WEBPACK FOOTER //
// src/components/find.vue